// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
} from 'common.data';

// Global Enums
import {
  webPages,
  webSections,
} from 'common.enums';

// Global Components
import * as React from 'react';
import {
  NavLink,
} from 'react-router-dom';

// Helpers
import ErrorLog from '@vroskus/library-sentry/dist/browser';
import {
  getLocalItemBasePath,
} from '../../../../helpers';

// Services
import Services from '../../../../services';

// Components
import Loader from '../../../layout/Loader';
import Section from '../../../layout/Section';

// Types
import type {
  $ReducerState,
} from '../../../../redux';

export type $OwnProps = $Translate & {
  item: $Model<'Regatta'>;
};

export type $StateProps = {
  main: $ReducerState<'main'>;
};

export type $DispatchProps = Record<string, unknown>;

type $Props = $DispatchProps & $OwnProps & $StateProps;

type $State = {
  data: Array<$Model<'Championship'>>;
  loading: boolean;
};

class ChampionshipsSectionView extends React.Component<$Props, $State> {
  constructor(props: $Props) {
    super(props);

    this.state = {
      data: [],
      loading: false,
    };
  }

  componentDidMount(): void {
    this.getData();
    this.setupSocket();
  }

  setStateAsync(state: Partial<$State>): Promise<void> {
    return new Promise((resolve) => {
      this.setState(
        (pervState: $State) => ({
          ...pervState,
          ...state,
        }),
        resolve,
      );
    });
  }

  async getData(): Promise<void> {
    const {
      item,
    } = this.props;

    try {
      await this.setStateAsync({
        loading: true,
      });

      const data = await Services.Api.getRegattaChampionshipsSectionData({
        RegattaId: item.id,
      });

      await this.setStateAsync({
        data,
        loading: false,
      });
    } catch (error) {
      await this.setStateAsync({
        loading: false,
      });

      ErrorLog.exception(error as Error);
    }
  }

  setupSocket(): void {
    const {
      item,
    } = this.props;

    Services.Socket.on({
      action: (data) => {
        if (data.RegattaId === item.id && (data.modelName === 'Championship' || data.modelName === 'Regatta')) {
          this.getData();
        }
      },
      type: Services.Socket.type.modelChangedEvent,
    });
  }

  render() {
    const {
      item,
      main,
      t,
    } = this.props;
    const {
      data,
      loading,
    } = this.state;

    const basePath = getLocalItemBasePath({
      basePath: '/championship',
      regions: main.regions,
      RegionSeasonId: item.RegionSeasonId,
    });

    return (data.length > 0 ? (
      <Section
        id={webSections[webPages.regattaPage].championships}
        title={t('Part of championships')}
      >
        <Loader
          className={'overflow-x-auto flex flex-row'}
          fade
          loading={loading === true}
        >
          <>
            {data.map((dataItem: $Model<'Championship'>) => (
              <NavLink
                className={'btn btn_primary btn_outlined uppercase whitespace-nowrap px-2 md:px-3 py-1 mr-3'}
                end
                key={dataItem.id}
                title={t('Championship page')}
                to={`${basePath}/${dataItem.Slug || dataItem.id}`}
              >
                <em className={'la la-trophy text-2xl'} />
                <span className={'ml-2'}>
                  {dataItem.Name}
                </span>
              </NavLink>
            ))}
          </>
        </Loader>
      </Section>
    ) : null);
  }
}

export default ChampionshipsSectionView;
